export const getInsertionOrderDetailsCellStyles = () => ({
  InsertionOrderDetailsButton: {
    width: '100%',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    display: 'inline-block',
  },
});
